<template>
  <span>
    <el-tooltip class="item" effect="dark" :content="$t(content)" placement="top">
      <copy-value :val="val">
        <span class="cursor">{{val}}</span>
      </copy-value>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: 'clickCopy',
  props: {
    val: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: 'common.clickCopy',
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/clickCopy.vue